// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASIC */
.Login {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  width: 450px !important;
  max-width: 100%;
  position: relative;
  padding: 20px 0 24px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid lightgrey;
  box-sizing: border-box;
}
#formContent .top-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 30px 0 34px;
  margin: 0 0 12px;
  font-size: 20px !important;
  font-weight: bold;
  color: #1a1a1a;
}
#formContent .top-head .auth-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
#formContent .top-head .auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#formContent .top-head .auth-modal-close mat-icon {
  color: #606060;
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;
}
#formContent .top-head .auth-modal-close:hover mat-icon {
  color: #333;
}
#formContent input {
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 16px;
  background: #fff;
  border: 1px solid lightgray;
}
#formContent input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent .alert-danger {
  width: 85%;
  margin: 0 auto 12px;
  font-size: 13px;
}
#formContent .commonbuttton,
#formContent .btn-primary {
  margin-top: 4px;
  margin-bottom: 8px;
}

.activation-info {
  color: #4a5568;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  margin: 0 auto 16px;
  padding: 0 28px;
  max-width: 420px;
  text-align: center;
}

.activation-info--emphasis {
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 20px;
  margin-bottom: 12px;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
}

.fadeIn.third {
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  animation-delay: 1s;
}

.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.img-div-left {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}

@media screen and (max-width: 520px) {
  #formContent {
    width: 100% !important;
    padding: 16px 0 20px;
  }
  .activation-info {
    padding: 0 16px;
  }
  #formContent .top-head {
    padding: 4px 16px 0;
  }
}
:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent .top-head {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) #formContent input::-webkit-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input::-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-ms-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover mat-icon {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .activation-info {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .activation-info--emphasis {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
  border-bottom-color: #5ea1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/activateaccount/activateaccount.component.scss"],"names":[],"mappings":"AACA,UAAA;AAEA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,kCAAA;EACA,aAAA;AADF;;AAIA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AADF;;AAIA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EAEE,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EAEA,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;AAFJ;AAII;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAFN;AAIM;EACE,qCAAA;AAFR;AAKM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAHR;AAMM;EACE,WAAA;AAJR;AASE;EACE,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAPJ;AASI;EACE,qCAAA;AAPN;AASI;EACE,qCAAA;AAPN;AASI;EACE,qCAAA;AAPN;AASI;EACE,qCAAA;AAPN;AAWE;EACE,UAAA;EACA,mBAAA;EACA,eAAA;AATJ;AAYE;;EAEE,eAAA;EACA,kBAAA;AAVJ;;AAcA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AAXF;;AAcA,SAAA;AAEA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;EACA,gCAAA;AAZF;;AAeA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AAbF;;AAgBA;;;EAGE,yBAAA;AAbF;;AAgBA;;;EAOE,sBAAA;AAbF;;AAgBA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;EACA,sBAAA;AAbF;;AAgBA;;EAEE,sBAAA;EACA,gCAAA;AAbF;;AAgBA;;EAEE,cAAA;AAbF;;AAgBA,eAAA;AAEA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAdF;AA8BA;EACE;IACE,UAAA;IAEA,mCAAA;EAfF;EAiBA;IACE,UAAA;IAEA,eAAA;EAfF;AACF;AAkCA;EACE;IACE,UAAA;EAhBF;EAkBA;IACE,UAAA;EAhBF;AACF;AAmBA;EACE,UAAA;EAGA,2BAAA;EAGA,6BAAA;EAGA,sBAAA;AAjBF;;AAoBA;EAGE,qBAAA;AAjBF;;AAoBA;EAGE,qBAAA;AAjBF;;AAoBA;EAGE,qBAAA;AAjBF;;AAoBA;EAGE,mBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;;AAoBA;EACE,aAAA;AAjBF;;AAoBA;EACE,UAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE;IACE,sBAAA;IACA,oBAAA;EAjBF;EAoBA;IACE,eAAA;EAlBF;EAqBA;IACE,mBAAA;EAnBF;AACF;AAuBE;EACE,oCAAA;EACA,yBAAA;AArBJ;AAwBE;EACE,8BAAA;EACA,iDAAA;EACA,oDAAA;EACA,yBAAA;AAtBJ;AAwBI;EACE,yBAAA;AAtBN;AAyBI;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAvBN;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AA2BI;EACE,yBAAA;AAzBN;AA4BI;EACE,sDAAA;AA1BN;AA6BI;EACE,yBAAA;AA3BN;AA+BE;EACE,yBAAA;AA7BJ;AAgCE;EACE,yBAAA;AA9BJ;AAiCE;;EAEE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA/BJ;AAkCE;;EAEE,oCAAA;EACA,uCAAA;AAhCJ","sourcesContent":["\n/* BASIC */\n\n.Login {\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.banner {\n  margin-top: 200px;\n}\n\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  width: 450px !important;\n  max-width: 100%;\n  position: relative;\n  padding: 20px 0 24px;\n  -webkit-box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  text-align: center;\n  border: 1px solid lightgrey;\n  box-sizing: border-box;\n\n  .top-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 30px 0 34px;\n    margin: 0 0 12px;\n    font-size: 20px !important;\n    font-weight: bold;\n    color: #1a1a1a;\n\n    .auth-modal-close {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: none;\n      border-radius: 50%;\n      margin-left: auto;\n      margin-right: 0;\n      padding: 0;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      mat-icon {\n        color: #606060;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        transition: color 0.2s ease;\n      }\n\n      &:hover mat-icon {\n        color: #333;\n      }\n    }\n  }\n\n  input {\n    margin-bottom: 16px;\n    color: rgba(0, 0, 0, 0.54) !important;\n    font-size: 16px;\n    background: #fff;\n    border: 1px solid lightgray;\n\n    &::-webkit-input-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &::-moz-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-ms-input-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-moz-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n  }\n\n  .alert-danger {\n    width: 85%;\n    margin: 0 auto 12px;\n    font-size: 13px;\n  }\n\n  .commonbuttton,\n  .btn-primary {\n    margin-top: 4px;\n    margin-bottom: 8px;\n  }\n}\n\n.activation-info {\n  color: #4a5568;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.45;\n  margin: 0 auto 16px;\n  padding: 0 28px;\n  max-width: 420px;\n  text-align: center;\n}\n\n.activation-info--emphasis {\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-top: 20px;\n  margin-bottom: 12px;\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  box-sizing: border-box;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n}\n\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n.img-div-left {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10002;\n}\n\n@media screen and (max-width: 520px) {\n  #formContent {\n    width: 100% !important;\n    padding: 16px 0 20px;\n  }\n\n  .activation-info {\n    padding: 0 16px;\n  }\n\n  #formContent .top-head {\n    padding: 4px 16px 0;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n    color: #e5e7eb !important;\n\n    .top-head {\n      color: #e5e7eb !important;\n    }\n\n    input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n\n      &::-webkit-input-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &::-moz-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &:-ms-input-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &:-moz-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n    }\n\n    .auth-modal-close mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .auth-modal-close:hover {\n      background-color: rgba(255, 255, 255, 0.08) !important;\n    }\n\n    .auth-modal-close:hover mat-icon {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .activation-info {\n    color: #cbd5e1 !important;\n  }\n\n  .activation-info--emphasis {\n    color: #e5e7eb !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n    border-bottom-color: #5ea1d8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
